module.exports = __webpack_public_path__ + "img/montanas.dbf03df3.png";